/**
 * Конфиг API/OAuth по домену.
 * Один бандл для всех доменов: выбор по window.location.hostname.
 */

export { resolveAbsoluteUrl } from "@medme/api-client"

export type AppConfig = {
	organizationApiUrl: string
	corev2ApiUrl: string
	oauthUrl: string
	clientId: string
}

const CLIENT_ID = "6a20157cd18d13dd6c0b9b6c"

function getHostname(): string {
	if (typeof window === "undefined") return ""
	return window.location.hostname
}

function getPortSuffix(): string {
	if (typeof window === "undefined") return ""
	const port = window.location.port
	return port ? `:${port}` : ""
}

function buildDynamicConfig(hostname: string): AppConfig {
	const parts = hostname.split(".")
	const rootDomain = parts.slice(-2).join(".")
	const envParts = parts.slice(1, -2)
	const envSegment = envParts.length > 0 ? `.${envParts.join(".")}` : ""
	const portSuffix = getPortSuffix()

	const buildUrl = (sub: string) =>
		`//${sub}${envSegment}.${rootDomain}${portSuffix}`

	return {
		organizationApiUrl: `${buildUrl("organization-api")}/api/v1`,
		corev2ApiUrl: buildUrl("apiv2"),
		oauthUrl: buildUrl("oauthv2"),
		clientId: CLIENT_ID,
	}
}

/**
 * Возвращает конфиг для текущего домена. Без сетевых запросов.
 */
export const getAppConfig = (): AppConfig => {
	const hostname = getHostname()
	return buildDynamicConfig(hostname)
}

export const getOAuthRedirectUri = (): string => {
	if (typeof window === "undefined") {
		return "/"
	}
	return window.location.origin + window.location.pathname
}

export const buildOAuthAuthorizeUrl = (config?: AppConfig): string => {
	const resolved = config ?? getAppConfig()
	const params = new URLSearchParams({
		type: "web_server",
		redirect_uri: getOAuthRedirectUri(),
		response_type: "code",
		client_id: resolved.clientId,
	})
	return `${resolved.oauthUrl}/authorize?${params.toString()}`
}
